import { PayloadAction } from '@reduxjs/toolkit';
import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* deleteMessageSaga(action: PayloadAction<string>) {
  yield call(SignalingSocket.send, { event: 'deleteChatMessage', data: { id: action.payload } });
}
